module.exports = __webpack_public_path__ + "img/test6.fbe371c9.png";